import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase Configuration
// Gerçek Firebase projeniz için bu değerleri Firebase Console'dan alın
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Firebase config doğrulaması
const validateFirebaseConfig = () => {
  const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  const missingKeys = requiredKeys.filter(key => !firebaseConfig[key as keyof typeof firebaseConfig]);
  
  if (missingKeys.length > 0) {
    console.error('❌ Firebase konfigürasyonu eksik!');
    console.error('Eksik değerler:', missingKeys);
    console.error('Lütfen .env dosyasında aşağıdaki değerleri ayarlayın:');
    missingKeys.forEach(key => {
      console.error(`REACT_APP_FIREBASE_${key.replace(/([A-Z])/g, '_$1').toUpperCase()}`);
    });
    return false;
  }
  
  console.log('✅ Firebase konfigürasyonu tamam');
  return true;
};

// Firebase'i başlat
let app;
if (getApps().length === 0) {
  if (validateFirebaseConfig()) {
    app = initializeApp(firebaseConfig);
    console.log('🔥 Firebase başlatıldı');
  } else {
    throw new Error('Firebase konfigürasyonu eksik! Lütfen .env dosyasını kontrol edin.');
  }
} else {
  app = getApps()[0];
}

// Firebase Authentication
export const auth = getAuth(app);

// Cloud Firestore
export const db = getFirestore(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Konfigürasyon bilgileri
export const firebaseConfigInfo = {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  isConfigured: validateFirebaseConfig()
};

export default app; 